<template>
  <div class="pivot-wrap">
    <div class='inner-wrap'>
      <h5 class='sm-tit'>행/열 전환(피벗 설정)</h5>
      <div class='info-txt fb-txt'>
        <p>대상 컬럼을 드래그하여 컬럼, 행, 값의 레이블을 설정 합니다.
          <br>컬럼과 행의 레이블에는 동일한 컬럼을 설정할 수 없습니다.
        </p>
      </div>
      <div class="drag-wrap">
        <div>
          <div class="col-tit ico-col">표측</div>
<!--          <div style="height: 40px" class="box" @drop.preven="ondrop($event,'rowOption')" @dragenter.prevent @dragover.prevent>
            <div class="box-item" :class="selectItem === item ? 'selected' : ''" tabindex="0" v-for="(item, index) in dragOption.rowOption" :key="index"
                 @click="colSelected($event, item, index)" @dragstart="startDrag($event, item, index, 'rowOption')" draggable="true"><p>{{item.name}}</p>
            </div>
          </div>-->
          <draggable class="list-group box" :list="list1" v-bind="dragOptions" group="pivot" ghost-class="ghost">
              <div class="list-group-item box-item" :class="selectItem === element ? 'selected' : ''" v-for="(element, index) in list1"
                   @click="colSelected($event, element, index)" :key="element.name">
                {{ element.name }}
              </div>
          </draggable>
        </div>
        <div class="btn-cols-move">
          <ul>
            <li><button type="button" class="cols-up" @click="itemMove('up')"><span class="hidden">컬럼 위로 이동</span></button></li>
            <li><button type="button" class="cols-down" @click="itemMove('down')"><span class="hidden">컬럼 아래로 이동</span></button></li>
          </ul>
        </div>
        <div>
          <div class="col-tit ico-row">표두</div>
<!--          <div style="height: 40px" class="box" @drop.preven="ondrop($event,'colOption')" @dragenter.prevent @dragover.prevent>
            <div class="box-item" :class="selectItem === item ? 'selected' : ''" tabindex="0" v-for="(item, index) in dragOption.colOption" :key="index"
                 @click="colSelected($event, item, index)" @dragstart="startDrag($event, item, index, 'colOption')" draggable="true"><p>{{item.name}}</p></div>
          </div>-->
          <draggable class="list-group box" :list="list2"  v-bind="dragOptions" group="pivot" ghost-class="ghost">
              <div class="list-group-item box-item" :class="selectItem === element ? 'selected' : ''" v-for="(element, index) in list2"
                   @click="colSelected($event, element, index)" :key="element.name">
                {{ element.name }}
              </div>
          </draggable>
        </div>
        <!-- 미설정 항목
        <div class="box" @drop.preven="ondrop($event,'removeOption')" @dragenter.prevent @dragover.prevent>
          <div class="box-item" v-for="(item, index) in dragOption.removeOption" :key="index"
                @dragstart="startDrag($event, item, index, 'removeOption')" draggable="true"><p>{{item.name}}</p></div>
        </div> -->
      </div>
    </div>
    <div class="pop-btn-box align-c">
      <button type="button" class="pop-btn bg-blue" @click="doPivot">실행</button>
      <button type="button" class="pop-btn line-white" @click="close">취소</button>
    </div>
  </div>
</template>

<script>

import draggable from "vuedraggable";

export default {
  name: "DownLoadPopup",
  props: {
    pivotOption: {},
    arrayHeader: {}
  },
  components: {
    draggable,
  },
  data() {
    return {
      list1: [],
      list2: [],
      isOpen: false,
      dragOption:{
        rowOption: [],
        colOption: [],
        removeOption: []
      },
      selectItem: {}
    }
  },
  mounted() {
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    dataSet() {
      this.dragOption.rowOption = this.titleSet(this.pivotOption.row, this.arrayHeader);
      this.dragOption.colOption = this.titleSet(this.pivotOption.col, this.arrayHeader);
      if (this.pivotOption.rm) {
        this.dragOption.removeOption = this.titleSet(this.pivotOption.rm, this.arrayHeader);
      } else {
        this.dragOption.removeOption = []
      }

      this.list1 = this.dragOption.rowOption;
      this.list2 = this.dragOption.colOption;

    },
    titleSet (arrData, arrTitle) {
      let result = []
      if (arrTitle !== undefined && arrTitle.length > 0) {
        arrData.forEach(item => {
          let header = arrTitle.find(header => header.titleCd === item);
          if (header !== undefined) {
            result.push({id:item, name:header.levelTitle, selected:false})
          } else {
            result.push({id:item, name:item, selected:false})
          }
        })
      } else {
        arrData.forEach(item => {
          result.push({id:item, name:item, selected:false})
        })
      }
      return result
    },
    startDrag(event, item, index, start) {
      event.dataTransfer.dropEffect = "move";
      event.dataTransfer.effectAllowed = "move"
      event.dataTransfer.setData("itemIndex", index)
      event.dataTransfer.setData("startOption", start)
    },
    ondrop (event, option) {
      const itemIndex = (event.dataTransfer.getData("itemIndex"));
      const startDrag = (event.dataTransfer.getData("startOption"));
      const moveItem = this.dragOption[startDrag][itemIndex];
      this.dragOption[startDrag].splice(itemIndex, 1);
      this.dragOption[option].push(moveItem);
      document.querySelectorAll('.box-item').forEach((item) => {
        item.classList.remove('selected')
      })
    },
    itemMove (type) {
      let startOption;
      let endOption;
      if (type === 'down'){
        startOption = 'rowOption';
        endOption = 'colOption';
      } else if (type === 'up') {
        startOption = 'colOption';
        endOption = 'rowOption';
      }
      let index = this.dragOption[startOption].findIndex(item => item === this.selectItem)
      if (index !== -1) {
        this.dragOption[startOption].splice(index, 1);
        this.dragOption[endOption].push(this.selectItem);
      }
    },
    open() {
      this.dataSet();
      this.isOpen = true;
    },

    close() {
      //this.isOpen = false;
      this.$parent.filterBoxClose()
    },

    doPivot() {
      /*if (this.dragOption.rowOption.length === 0 || this.dragOption.colOption.length === 0) {
        alert("표측, 표두 항목에 적어도 1개이상의 값이 설정되어 있어야 합니다.");
        return;
      }*/
      this.pivotOption.row = this.dragOption.rowOption.map(item => item.id);
      this.pivotOption.col = this.dragOption.colOption.map(item => item.id);
      this.pivotOption.rm = this.dragOption.removeOption.map(item => item.id);
      this.$emit('pivot-apply', this.pivotOption);
      this.close();
    },

    colSelected(evt, item, index) {
      this.selectItem = item;
    }
  },

}
</script>
<style>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  align-content: flex-start;
}

.list-group > span {
  display: flex;
  gap: 8px;
}

.list-group .box-item {
  height: 36px;
}

</style>
